import { hookstate, State, useHookstate } from "@hookstate/core";
import { devtools } from "@hookstate/devtools";
import { createContext, useEffect } from "react";
import { FullPageSpinner } from "../Common/FullPageSpinner";
import { Utils } from "../Utilities/Utils";
import { SettingsSections } from "../CapsitechAccountsComponents/Services/SettingService";

export enum ITypeIIsClientSpecificRoleDataType {
  Vouchers,
  Setting,
  TandC,
}

export interface IIsClientSpecificRolePremissionType {
  View: string[];
  Edit: string[];
  Delete?: string[];
  Add?: string[];
  Print?: string[];
  Authorize?: string[];
}

export interface IIsClientSpecificRoleDataType {
  Vouchers: IIsClientSpecificRolePremissionType;
  Setting: IIsClientSpecificRolePremissionType;
  TandC: IIsClientSpecificRolePremissionType;
}

export interface IIsClientSpecificRoleVouchersData {
  type: SettingsSections;
  data: IIsClientSpecificRoleDataType;
}

export interface IRole {
  clientIdList: any[];
  roleId: string;
  roleName: string;
  description: string;
  accessSettings: string[];
  isClientSpecificRoleVouchersData?: IIsClientSpecificRoleVouchersData[];
}

export interface IRoleArray {
  roleList: IRole[];
  loaded: boolean;
}

interface IRoleContextProps {
  getRoleDetailsFromServer: () => Promise<void>;
}

export const stateRoleContext = hookstate<IRoleArray>(
  {
    roleList: [],
    loaded: false,
  },
  devtools({ key: "role-context-state" })
);

const wrapRoleContextState = (r: State<IRoleArray>) => {
  const setCurrentRole = (role?: IRole[]) => {
    const getRole: IRole[] = Utils.getLocal("RoleList");
    console.log("role", role, "getRole", getRole);
    if (role) {
      if (getRole?.length > 0) {
        r.merge({
          roleList: [...role, ...getRole],
          loaded: true,
          // id: role.id,
          // name: role.name,
          // description: role.description,
          // accessSettings: role.accessSettings,
        });
        Utils.setLocal("RoleList", [...role, ...getRole]);
      } else {
        r.merge({
          roleList: role,
          loaded: true,
        });
        Utils.setLocal("RoleList", role);
      }
    } else {
      r.merge({
        // id: "",
        // name: "",
        // description: "",
        // accessSettings: [],
        // clientList: [],
        roleList: [],
        loaded: true,
      });
    }
  };

  const removeCurrentRole = () => {
    r.merge({
      // id: "",
      // name: "",
      // description: "",
      // accessSettings: [],
      // clientList: [],
      roleList: [],
      loaded: true,
    });
  };
  return {
    getRole: () => r.roleList.get({ noproxy: true }),
    setCurrentRole,
    removeCurrentRole,
  };
};

export const useRole = () => wrapRoleContextState(stateRoleContext);

export const RoleContext = createContext<IRoleContextProps>({} as any);

export function RoleProvider(props: { children?: any }) {
  const state = useHookstate(stateRoleContext);
  const getRoleDetailsFromServer = async () => {
    //  debugger
    let role = Utils.getLocal("RoleList");

    console.log("role", role);

    if (role) {
      state.merge({
        roleList: role,
        loaded: true,
      });
    } else {
      state.merge({
        roleList: [
          {
            clientIdList: [],
            roleId: "",
            roleName: "",
            description: "",
            accessSettings: [],
            isClientSpecificRoleVouchersData: [],
          },
        ],
        // roleList: role,
        loaded: true,
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      getRoleDetailsFromServer();
    };

    fetchData();
    return () => {
      console.debug("Role context unloaded");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!state.loaded.value) {
    return <FullPageSpinner label="Loading..." />;
  }
  //console.debug('role-context rendered');
  return (
    <RoleContext.Provider
      value={{
        getRoleDetailsFromServer,
      }}
      {...props}
    />
  );
}
